export default __webpack_public_path__ + "static/media/github.df941249.svg";